import api, { handleAPIErrors } from 'shared/api'

const FETCH_REQUEST = 'yourCompany/FETCH_REQUEST'
const FETCH_SUCCESS = 'yourCompany/FETCH_SUCCESS'
const FETCH_FAILURE = 'yourCompany/FETCH_FAILURE'
const FETCH_FILTER_REQUEST = 'yourCompany/FETCH_FILTER_REQUEST'
const FETCH_FILTER_SUCCESS = 'yourCompany/FETCH_FILTER_SUCCESS'
const FETCH_FILTER_FAILURE = 'yourCompany/FETCH_FILTER_FAILURE'
const FETCH_ALL_REQUEST = 'yourCompany/FETCH_ALL_REQUEST'
const FETCH_ALL_SUCCESS = 'yourCompany/FETCH_ALL_SUCCESS'
const FETCH_ALL_FAILURE = 'yourCompany/FETCH_ALL_FAILURE'

const initialState = {
    result: {data:[], pay_for_performance_chart_data:{},pay_magnitude_chart_data:{}},
    allResult:[],
    loaded: false,
    loading: false,
    errors: []
}

export function fetchRequest(payload = {}) {
    return {
        type: FETCH_REQUEST,
    }
}

export function fetchSuccess(payload) {
    return {
        type: FETCH_SUCCESS,
        payload,
    }
}

export function fetchFailure(errors = []) {
    return {
        type: FETCH_FAILURE,
        errors,
    }
}

export function fetchAllRequest(payload = {}) {
    return {
        type: FETCH_ALL_REQUEST,
    }
}

export function fetchAllSuccess(payload) {
    return {
        type: FETCH_ALL_SUCCESS,
        payload,
    }
}

export function fetchAllFailure(errors = []) {
    return {
        type: FETCH_ALL_FAILURE,
        errors,
    }
}

export function fetchFilterRequest(payload = {}) {
    return {
        type: FETCH_FILTER_REQUEST,
    }
}

export function fetchFilterSuccess(payload) {
    return {
        type: FETCH_FILTER_SUCCESS,
        payload,
    }
}

export function fetchFilterFailure(errors = []) {
    return {
        type: FETCH_FILTER_FAILURE,
        errors,
    }
}
export function loadAllCompaniesList() {
    return (dispatch) => {
        dispatch(fetchRequest())

        const promise = api('api/v1/peers/associated_companies', {}, {}, true)
            .then(response => response.json().then(json => ({ json, response })))
            .then(({ json, response }) => {
                if (!response.ok) {
                    return Promise.reject(json)
                }
                dispatch(fetchAllSuccess(json))
            })
            .catch((exception) => {
                handleAPIErrors(exception, (errors) => {
                    dispatch(fetchAllFailure(errors))
                })
            })

        return promise
    }
}

export function loadAllCompaniesListAndFetchFirst() {
    return (dispatch) => {
        dispatch(fetchRequest())

        const promise = api('api/v1/peers/associated_companies', {}, {}, true)
            .then(response => response.json().then(json => ({ json, response })))
            .then(({ json, response }) => {
                if (!response.ok) {
                    return Promise.reject(json)
                }
                dispatch(fetchAllSuccess(json))
                dispatch(loadYourCompanyData({company_id: json[0].id, peer_group_title: 'IssIndustry'}))
            })
            .catch((exception) => {
                handleAPIErrors(exception, (errors) => {
                    dispatch(fetchAllFailure(errors))
                })
            })

        return promise
    }
}


export function loadYourCompanyData(options) {
    return (dispatch) => {
        dispatch(fetchRequest())
            const promise = api('api/v1/peers/your_company', options, {}, true)
            .then(response => response.json().then(json => ({ json, response })))
            .then(({ json, response }) => {
                if (!response.ok) {
                    return Promise.reject(json)
                }
                dispatch(fetchSuccess(json))
            })
            .catch((exception) => {
                handleAPIErrors(exception, (errors) => {
                    dispatch(fetchFailure(errors))
                })
            })

        return promise
    }
}

// Reducer
export default function reducer(state = initialState, action = {}) {
    const { payload, type, errors } = action

    switch (type) {
        case FETCH_REQUEST:
            return Object.assign({}, state, {
                loading: true,
            })
        case FETCH_SUCCESS:
            return Object.assign({}, state, {
                loading: false,
                loaded: true,
                errors: [],
                result: payload
            })
        case FETCH_FAILURE:
            return Object.assign({}, state, {
                loaded: false,
                loading: false,
                errors,
            })
        case FETCH_ALL_REQUEST:
            return Object.assign({}, state, {
                allLoading: true,
            })
        case FETCH_ALL_SUCCESS:
            return Object.assign({}, state, {
                loading: false,
                loaded: true,
                errors: [],
                allResult: payload
            })
        case FETCH_ALL_FAILURE:
            return Object.assign({}, state, {
                loaded: false,
                loading: false,
                errors,
            })
        case FETCH_FILTER_REQUEST:
            return Object.assign({}, state, {
                filterLoading: true,
            })
        case FETCH_FILTER_SUCCESS:
            return Object.assign({}, state, {
                filterLoading: false,
                filterLoaded: true,
                errors: [],
                result: payload
            })
        case FETCH_FILTER_FAILURE:
            return Object.assign({}, state, {
                filterLoaded: false,
                filterLoading: false,
                errors,
            })
        default:
            return state
    }
}

